import { AppAreaConfig } from '@/funnels/@types'
import walkingFemale from './activity-female-walking'

const appAreaConfig: AppAreaConfig = {
	appArea: 'activity-female-walking-japanese',
	options: {
		userFlags: ['hasAccessToWalkingVideos'],
		userTags: ['japanese_walking'],
	},
	landing: {
		ids: ['loader-walking-japanese-f', 'age-walking-japanese-f'],
		route: {
			path: '/walking-japanese-f',
			name: 'walking-japanese-funnel',
		},
	},
	funnel: {
		id: 'ob-female-activity-walking-japanese',
		route: {
			path: '/walking-japanese-f/ob/:page(.*)?',
			// @ts-expect-error - Legacy: route.name не совпадает с appArea, будет исправлено позже
			name: 'female-activity-walking-japanese',
		},
		slug: 'activity-female-walking-japanese',
		locale: ['en'],
		redirectTo: {
			always: {
				// DEV-34114: `body-focus-areas` не существует в ob-female-activity-walking —
				// раньше неизвестный слаг спасал hide_landing_screens (падал на первый ВИДИМЫЙ
				// = journey-starts). Флаг убран → неизвестный слаг упал бы на welcome-loader
				// (лендинг). Валидный не-лендинг-слаг, как у sibling truncated-фидеров
				// (nordic / tai-chi): `focus-area`.
				appArea: walkingFemale,
				page: 'focus-area',
			},
		},
	},
}

export default appAreaConfig
